import { Maybe } from '@passionware/monads';
import { z } from 'zod';

// BooleanFilter Type
export type BooleanFilter = {
  operator: 'equal';
  value: boolean;
};

// Utility Functions
export const booleanFilter = {
  // Returns the sign for the filter operator (only "equal" for now)
  getOperatorSign: (): string => '=',

  // Changes the value in the filter
  changeValue: (filter: BooleanFilter, value: boolean): BooleanFilter => ({
    ...filter,
    value
  }),

  // Creates a default boolean filter
  createDefault: (value: boolean = true): BooleanFilter => ({
    operator: 'equal',
    value
  }),
  matches(filter: Maybe<BooleanFilter>, value: boolean): boolean {
    if (!filter) return true;
    return filter.value === value;
  }
};

// Zod Schema for BooleanFilter
export const booleanFilterSchema = z.object({
  operator: z.literal('equal'), // only "equal" is allowed as an operator
  value: z.preprocess(v => {
    // Handle string representations
    if (typeof v === 'string') {
      const lower = v.toLowerCase();
      if (lower === 'true' || lower === '1') return true;
      if (lower === 'false' || lower === '0') return false;
    }
    // Handle numeric representations (common in URL query params)
    if (typeof v === 'number') {
      if (v === 1) return true;
      if (v === 0) return false;
    }
    // Pass through already boolean values
    return v;
  }, z.boolean())
});
